import { isImmutable } from 'immutable';

import { isObject } from '@/utils/isObject';

export function getSize(instance) {
  if (typeof instance === 'string') {
    return instance.length;
  } else if (!isObject(instance)) {
    return 0;
  } else if (isImmutable(instance)) {
    return instance.size;
  } else if ('length' in instance && Number.isFinite(instance.length)) {
    return instance.length;
  } else {
    return Object.keys(instance).length;
  }
}
